module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1025-51b2bef8215a6d2cee815b658d7782d1.png";